import Guid from "~/helpers/guid";
import { FormApplicationStatusType } from "../../../../common/enums/forms/workflowSteps/formApplicationStatusType";
import Form from "../form";
import FormSectionFactory from "../formSections/formSectionFactory";
import ApprovalStep from "./approvalStep";
import AwardStep from "./awardStep";
import CertificateStep from "./certificateStep";
import FormStep from "./formStep";
import InitialStep from "./initialStep";
import MappingStep from "./mappingStep";
import PaymentStep from "./paymentStep";
import ProcessFlowWorkflowStep from "./processFlowWorkflowStep";
import WorkflowStep from "./workflowStep";
import { WorkflowType } from "~/enums/forms/workflowSteps/workflowType";

export default class WorkflowStepFactory {

  static create(form: Form, workflowType: WorkflowType): WorkflowStep {
    let ws: WorkflowStep = null;

    switch (workflowType) {
      case WorkflowType.formSection:
      case WorkflowType.approval:
        const approvalStep = new ApprovalStep(form);
        approvalStep.defineProperty('has_form_section', workflowType === WorkflowType.formSection);
        approvalStep.defineProperty('is_multi_section', false);
        approvalStep.defineProperty('has_approval', workflowType === WorkflowType.approval);

        // TODO: WorkflowStepFactory should not know how to create form section
        if (workflowType === WorkflowType.formSection) {
          approvalStep.form_section = FormSectionFactory.create(approvalStep);
          approvalStep.appendAction({title: 'Submit', style: 'green', sort_order: 0}, false);
        } else if (workflowType === WorkflowType.approval) {
          approvalStep.appendAction({title: 'Approve', style: 'green', sort_order: 0}, false);
          approvalStep.appendAction({title: 'Reject', style: 'red', sort_order: 1}, false);
        }

        ws = approvalStep;
        ws.defineProperty('application_status', FormApplicationStatusType.inReview);
        break;
      case WorkflowType.form:
        ws = new FormStep(form);
        ws.defineProperty('application_status', FormApplicationStatusType.inReview);
        break;
      case WorkflowType.initialStep:
        ws = new InitialStep(form);
        ws.defineProperty('application_status', FormApplicationStatusType.draft);
        break;
      case WorkflowType.payment:
        ws = new PaymentStep(form);
        ws.defineProperty('application_status', FormApplicationStatusType.inReview);
        break;
      case WorkflowType.licenseStatusChange:
        ws = new AwardStep(form);
        break;
      case WorkflowType.certificate:
        ws = new CertificateStep(form);
        ws.defineProperty('application_status', FormApplicationStatusType.draft);
        break;
      case WorkflowType.mapping:
        ws = new MappingStep(form);
        ws.defineProperty('application_status', FormApplicationStatusType.draft);
        break;
      case WorkflowType.processFlow:
        ws = new ProcessFlowWorkflowStep(form);
        ws.defineProperty('application_status', FormApplicationStatusType.draft);
        break;
      default:
        break;
    }

    if (Object.keys(ws.actions).length === 0) {
      ws.appendAction({sort_order: 0}, false);

    }
    if (workflowType === WorkflowType.approval && Object.keys(ws.overdue_submission_actions).length === 0){
      ws.appendOverdueSubmissionAction(false);

    }
    ws.parent = form;
    ws.rootModel = form;
    ws.defineProperty('client_id', Guid.create());


    return ws;
  }
}